import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { RestApiService } from '@/services'
import { ApplicationState } from '@/state/root.models'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import { GetAllPaginationPayload, WageringState } from '../models'

import { WAGERING } from './api.routes'

const apiService: RestApiService = Container.get(RestApiService)

export const getAllCategoriesThunk = createAsyncThunk(
  ActionTypes.GET_ALL_CATEGORIES,
  async (payload: GetAllPaginationPayload, thunkAPI) => {
    const { hideFullLoading, ...queries } = payload

    try {
      apiService.requestParams = {
        method: 'GET',
        endpoint: WAGERING.CATEGORIES_LIST,
        queries: jsonToQueryString(queries),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      if (!hideFullLoading) {
        thunkAPI.dispatch(setLoadingFullAction(true))
      }

      const response: any = await apiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getAllCategoriesExtraReducer = (
  builder: ActionReducerMapBuilder<WageringState>,
) => {
  builder.addCase(getAllCategoriesThunk.pending, (state) => {
    state.isLoading = true
    state.isLoadingCategories = true
  })
  builder.addCase(getAllCategoriesThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.isLoadingCategories = false
    state.categoriesList = payload
  })
}

export default getAllCategoriesExtraReducer
